import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './Title.module.scss';

const Title = ({ tag, red, children, flexible, width, selected }) => {
  const { isDarkMode } = useTheme();

  const t = fromAnyToTrimmed(tag);

  return (
    <div
      data-bem="Title"
      data-tag={t}
      className={cn({
        [CN.component]: true,
        [CN.flexible]: flexible,
        [CN[`${width}Width`]]: width,
        [CN.normalWidth]: !width,
        [CN.dark]: isDarkMode,
      })}
    >
      <span
        className={cn({
          [CN.title]: true,
          [CN.selected]: selected,
          [CN.danger]: red,
        })}
      >
        {children}
      </span>
    </div>
  );
};

export default Title;
